import { Input as AntdInput, InputProps } from "antd"
import { useEffect, useState } from "react"
import { InputNames } from "types/props"
import "./Input.scss";
import { formatInsString } from "lib/utils";
import { useLanguage } from "locales";

const INSInput = ({ hidePseudoName, ...props }: InputProps & any): JSX.Element => {
    const { languages } = useLanguage()
    const [formatIns, setFormatIns] = useState(false)
    const [pseudoValue, setPseudoValue] = useState(false)
    const [labelIns, setLabelIns] = useState("")

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if ([InputNames.BIRTH_LASTNAME, InputNames.FIRST_BIRTH_FIRSTNAME].includes(props.name)) {
            setFormatIns(true)
            props.name === InputNames.FIRST_BIRTH_FIRSTNAME && setLabelIns(languages.pseudo_firstname)
            props.name === InputNames.BIRTH_LASTNAME && setLabelIns(languages.pseudo_lastname)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.name])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (props.conditionChecked) {
            const pseudoValueName = props.name === InputNames.BIRTH_LASTNAME ? InputNames.LASTNAME : InputNames.FIRSTNAME
            setPseudoValue(props.formRef?.getFieldValue(pseudoValueName))
        } else {
            setPseudoValue(undefined)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.conditionChecked])

    return <>
        <AntdInput {...props} value={formatIns && props.value ? formatInsString(props.value) : props.value} style={{ color: props.disabled ? "#7A7A7A" : null }} />
        {
            formatIns && !hidePseudoName && !props.disabled && (
                <div className="ins-label">
                    <span>{labelIns} : {pseudoValue ?? props.value}</span>
                </div>
            )
        }
    </>
}

export default INSInput